import { render } from "./TabbyHeader.vue?vue&type=template&id=6e5f94c5&scoped=true"
import script from "./TabbyHeader.vue?vue&type=script&lang=js"
export * from "./TabbyHeader.vue?vue&type=script&lang=js"

import "./TabbyHeader.vue?vue&type=style&index=0&id=6e5f94c5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6e5f94c5"

export default script